// extracted by mini-css-extract-plugin
module.exports = {"t1vjqxs":"t1vjqxs"};